const roundToDecimalPlaces = (amount, decimals) =>
    parseFloat(Math.round(amount * 100) / 100).toFixed(decimals);

const convertAmount = (rate, amountInSek, decimals) => {
    return roundToDecimalPlaces(rate * amountInSek, decimals);
};

export default {
    convertAmount,
    roundToDecimalPlaces
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-utils.js